export { CMS_LOCALES } from '../../../../../../api/src/_core/craft-cms/carft-cms.model';
import { Country } from '../../../../../../api/src/_core/utils/utils.data';
import { Country as CountryModel } from './global.model';

// This will be populated from Strapi countries
let cachedCountryOptions: { value: string; text: string }[] | null = null;

// Hardcoded translations as fallback for known countries
const COUNTRY_TRANSLATIONS = {
	[Country.US]: $localize `:Country name@@countryNameUnitedStates:United States`,
	[Country.CA]: $localize `:Country name@@countryNameCanada:Canada`,
	[Country.CN]: $localize `:Country name@@countryNameChina:China`
};

export function COUNTRY_OPTIONS() {
	// Return cached countries if available
	if (cachedCountryOptions) {
		return cachedCountryOptions;
	}

	// Fallback to hard-coded values with translations if Strapi data hasn't loaded yet
	return [
		{ value: Country.US, text: COUNTRY_TRANSLATIONS[Country.US] },
		{ value: Country.CA, text: COUNTRY_TRANSLATIONS[Country.CA] },
		{ value: Country.CN, text: COUNTRY_TRANSLATIONS[Country.CN] }
	];
}

/**
 * Set country options from Strapi data
 * This is called by GlobalService after fetching countries from CMS
 * Falls back to hardcoded translations for known countries if Strapi doesn't provide localized names
 */
export function setCountryOptions(countries: CountryModel[]) {
	if (!countries || countries.length === 0) {
		return;
	}
	
	cachedCountryOptions = countries.map(country => ({
		value: country.alpha2Code,
		// Use Strapi localized name if available, otherwise fallback to hardcoded translations
		text: country.name || COUNTRY_TRANSLATIONS[country.alpha2Code] || country.alpha2Code
	}));
}
